import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { TabMenu } from 'primereact/tabmenu';
import { Toast } from 'primereact/toast';

import Header from '@components/Header';
import GeneralData from '@components/Evaluator/GeneralData';
import ContactInformation from '@components/Evaluator/ContactInformation';
import AssociateManagers from '@components/Evaluator/AssociateManagers';
import Coordinators from '@components/Evaluator/Coordinators';
import AddEvaluatorModal from '@components/Evaluator/AddEvaluatorModal';

import { getListEvaluators, addEvaluator } from '@actions/evaluators'
import { validatePermissionAction } from '@actions/sessionPermission';
import { sendActionToBitacora  } from '@actions/bitacora';

import { SET_VALUES_EVALUATOR, CLEAR_VALUES_EVALUATOR } from '@constants/actionType'
import catalogPermissionsId from '@constants/catalogPermissionsId';

import store from '@store'

// import './style.scss'

class Evaluators extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      evaluatorSelect: null,
      evaluators: [],
      tabsOptions: [],
      activeTabIndex: 0,
      modalAddEvalueator: false,
    };
  }

  async componentDidMount() {
    await this.onGetEvaluators()
    await this.onChangeEvaluator({target: {name: 'evaluatorSelect', value: this.state.evaluators[0]}})
    this.setOptionsTabs()
    this.setState({loadingPage: false})
  }

  setOptionsTabs = () => {
    const { t, validatePermissionAction } = this.props
    const tabs = []
    let hasPermissionEv = false
    let hasPermissionGe = false
    let hasPermissionCo = false
    if (validatePermissionAction(catalogPermissionsId.ADMINISTRAR_EVALUADORES)) {
      tabs.push({label: t('Datos Generales'), key: 0})
      tabs.push({label: t('Datos de contacto'), key: 1})
      hasPermissionEv = true
    } 
    if (validatePermissionAction(catalogPermissionsId.ADMINISTRAR_GESTORES)) {
      tabs.push({label: t('Gestores asociados'), key: 2})
      hasPermissionGe = true
    }
    if (validatePermissionAction(catalogPermissionsId.ADMINISTRAR_COORDINADORES)) {
      tabs.push({label: t('Coordinadores'), key: 3})
      hasPermissionCo = true
    }

    // setTabInde Start
    if (!hasPermissionEv && hasPermissionGe) this.setState({activeTabIndex: 2})
    else if (!hasPermissionEv && hasPermissionCo) this.setState({activeTabIndex: 3})
    // setTabInde End
    return this.setState({tabsOptions: tabs })
  }

  onGetEvaluators = async () => {
    const { getListEvaluators } = this.props
    const response = await getListEvaluators('all', 'external')
    if (response?.data) {
      this.setState({evaluators: response?.data})
    } else {
      this.setState({evaluators: []})
    }
    return response
  }

  onAddEvaluator = async (data, justification) => {
    const { addEvaluator, sendActionToBitacora } = this.props
    const { evaluatorSelect } = this.state
    const response = await addEvaluator(data)
    if (!response?.status){
      const dataBitacora = {
        transactionName: 'altaEvaluador',
        reason: `${data.nombre} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      await this.onGetEvaluators()
      this.setState({ evaluatorSelect });
    }
  }

  onloadListEvaluators = async (data) => {
    const { evaluatorId } = this.props
    const response = await this.onGetEvaluators()
    const findEvaluator = (response?.data || []).find(item => item.id === evaluatorId)
    this.onChangeEvaluator({target: {name: 'evaluatorSelect', value: findEvaluator}})
  }

  onChangeEvaluator = async ({target}) => {
    await store.dispatch({type: CLEAR_VALUES_EVALUATOR})
    await store.dispatch({ type: SET_VALUES_EVALUATOR, payload: {loadingEvaluator: true}})
    await this.setEvaluatorToStateGlobal(target.value)
    this.setState({
      [target.name]: target.value
    });
    store.dispatch({ type: SET_VALUES_EVALUATOR, payload: {loadingEvaluator: false}})
  };

  setEvaluatorToStateGlobal = async (data) => store.dispatch({

      type: SET_VALUES_EVALUATOR,
      payload: {...data, contacto: data.contacto ? JSON.parse(data.contacto) : []}
    })
  
  onShowModalAddEvaluator = (value) => {
    this.setState({modalAddEvalueator: value})
  }

  onToalAction = () => {
    const { t } = this.props
    this.toast.show({
      severity: 'success',
      summary: t('Confirmación'),
      detail: t('La operación se ha realizado de manera éxitosa'),
      life: 3000,
    });
  }

  render() {
    const { history, t, loadingEvaluator, validatePermissionAction } = this.props;
    const { loadingPage, evaluators, evaluatorSelect, activeTabIndex, modalAddEvalueator,tabsOptions } = this.state;

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
        { validatePermissionAction(catalogPermissionsId.ADMINISTRAR_EVALUADORES) && (
          <Button
            label={t('Agregar Evaluador')}
            className="p-button-primary"
            onClick={() => this.onShowModalAddEvaluator(true)}
          />
        )}
      </>
    );

    const renderSteps = () => {
      switch (activeTabIndex) {
        case 0:
          return (
            // <h1>Datos Generales</h1>
            <GeneralData
              loadListEvaluators={this.onloadListEvaluators}
            />
          )
        case 1:
          return (
            <ContactInformation
              loadListEvaluators={this.onloadListEvaluators}
              toalAction={this.onToalAction}
            />
          )
        case 2:
          return (
            <AssociateManagers/>
          )
        case 3:
          return (
            <Coordinators/>
          )
        default:
          break;
      }
    }

    if (loadingPage) return true
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t('Evaluadores de Proceso de Debida Diligencia')} rightComponent={rightHeader} />
          <div className="card">
            {!loadingEvaluator && (
              <>
              <div className="p-col-12 p-mt-2">
                <label className="">{t('Empresa evaluadora')}:</label>
                <Dropdown
                  name="evaluatorSelect"
                  value={evaluatorSelect}
                  options={evaluators}
                  onChange={this.onChangeEvaluator}
                  optionLabel="nombre"
                  className="p-mt-2"
                  placeholder=""
                  style={{ width: '100%' }}
                />
              </div>
                <div className="p-col-12">
                  <TabMenu
                      model={tabsOptions}
                      activeIndex={activeTabIndex}
                      onTabChange={(e) => {
                        this.setState({ activeTabIndex: e.value.key })
                      }}
                    />
                </div>
                <div className="p-col-12">
                  {renderSteps()}
                </div>
              </>
            )}
          </div>
        </div>
        <Toast ref={(el) => (this.toast = el)} />
        { modalAddEvalueator && (
          <AddEvaluatorModal
            onHidden={() => this.onShowModalAddEvaluator(false)}
            onAction={this.onAddEvaluator}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loadingEvaluator: state.evaluator.loadingEvaluator,
  evaluatorId: state.evaluator.id,
});

const mapDispatchToProps = {
  getListEvaluators,
  addEvaluator,
  validatePermissionAction,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Evaluators);
